import React, { useState } from 'react';
import './About.css';
import chairmanImg from '../assets/about/chairman.jpg';
import ferdousImg from '../assets/about/ferdous.jpg';
import masudImg from '../assets/about/Masud.jpg';
import mkImg from '../assets/about/Mk.jpg';
import groupImg from '../assets/about/group.jpg';

const founders = [
  {
    name: 'Mosatofa Mahamud Arifee',
    role: 'Co-Founder',
    image: chairmanImg,
    bio: 'As one of the principal visionaries behind Chuti group, the Chairman provides strategic oversight and inspires the organisation to pursue bold ambitions in hospitality and resort excellence.',
  },
  {
    name: 'Alamgir Ferdous',
    role: 'Co-Founder',
    image: ferdousImg,
    bio: 'Alamgir Ferdous drives operational excellence across all resort properties, championing innovation, disciplined execution, and a culture built around guest satisfaction and memorable experiences.',
  },
  {
    name: 'Shamsul Islam Masud',
    role: 'Co-Founder',
    image: masudImg,
    bio: 'Masud is responsible for expanding our portfolio of resort destinations, forging strategic partnerships, and ensuring sustainable growth in the hospitality sector that benefits our communities.',
  },
  {
    name: 'Mostofa Kamal',
    role: 'Co-Founder',
    image: mkImg,
    bio: 'Mostofa Kamal leads the strategic roadmap of Chuti group, steering new resort ventures and empowering teams to deliver transformative hospitality experiences.',
  },
];

const About = () => {
  const [selectedFounder, setSelectedFounder] = useState(null);
  const openFounderModal = (founder) => setSelectedFounder(founder);
  const closeFounderModal = () => setSelectedFounder(null);
  return (
    <div className="about">
      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                Chuti group has been at the forefront of hospitality excellence
                for over half a century. We are committed to delivering exceptional
                resort experiences and luxury accommodations that create unforgettable
                memories for our guests.
              </p>
              <p>
                Our team of hospitality experts brings together diverse skills and experiences
                to create world-class resort destinations that meet the evolving needs
                of modern travelers seeking relaxation, adventure, and luxury.
              </p>
            </div>
            <div className="about-image">
              <img src={groupImg} alt="About Chuti group" />
            </div>
          </div>
        </div>
      </section>

      <section className="founders">
        <div className="container">
          <div className="founders-header">
            <h2>Our Founders</h2>
            <p className="founders-description">
              Visionary leaders who laid the foundation of Chuti group and continue to guide our
              journey with innovation, integrity, and a relentless pursuit of excellence.
              <br /><br />
              Through decades of dedication and strategic vision, our founders have transformed Chuti group from a humble beginning into Bangladesh&apos;s premier hospitality conglomerate. Their unwavering commitment to excellence, combined with innovative thinking and ethical business practices, has established a legacy that continues to inspire our team and delight our guests.
              <br /><br />
              Each founder brings unique expertise and passion to the organization, creating a dynamic leadership team that drives sustainable growth while maintaining the highest standards of service quality. Together, they have built a culture of innovation, integrity, and excellence that defines every aspect of our operations.
            </p>
          </div>
          <div className="founders-grid">
            {founders.map((founder) => (
              <div key={founder.name} className="founder-card">
                <div className="founder-image">
                  <img src={founder.image} alt={founder.name} />
                  <div className="image-overlay" />
                </div>
                <div className="founder-info">
                  <h3>{founder.name}</h3>
                  <span>{founder.role}</span>
                </div>
                <button
                  type="button"
                  className="founder-button"
                  onClick={() => openFounderModal(founder)}
                >
                  More Info
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedFounder && (
        <div className="founder-modal" role="dialog" aria-modal="true">
          <div className="founder-modal-backdrop" onClick={closeFounderModal} />
          <div className="founder-modal-content">
            <button
              type="button"
              className="founder-modal-close"
              aria-label="Close founder details"
              onClick={closeFounderModal}
            >
              ×
            </button>
            <div className="founder-modal-header">
              <div className="founder-modal-image">
                <img src={selectedFounder.image} alt={selectedFounder.name} />
              </div>
              <div className="founder-modal-info">
                <h3>{selectedFounder.name}</h3>
                <span>{selectedFounder.role}</span>
              </div>
            </div>
            <p className="founder-modal-description">{selectedFounder.bio}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;
